import {EventEmitter, Injectable} from '@angular/core';
import {Stage} from 'konva/lib/Stage';
import {KonvaEventObject} from 'konva/lib/Node';
import {Group} from 'konva/lib/Group';
import {IGraphAction, TGraphActionType} from '../models/graph-kn.model-interfaces';
import {GraphKnDataService} from './graph-kn.data.service';

@Injectable({
    providedIn: 'root'
})
export class GraphKnContextMenuService {
    public contextAction: EventEmitter<IGraphAction> = new EventEmitter<IGraphAction>();

    constructor(
        private knDataService: GraphKnDataService,
    ) {
    }

    generateContextMenu(stage: Stage, menuNode: any) {
        stage.on('contextmenu', event => this.openContextMenu(event, stage));
        window.addEventListener('click', () => {
            menuNode.style.display = 'none';
        });
    }

    openContextMenu(event: KonvaEventObject<MouseEvent | TouchEvent, Stage | Group>, stage: Stage) {
        let contextMenuEl = document.getElementById('graph-context-menu') as HTMLElement
        let showContextMenu = this.knDataService.canvasObjectsMap.get(event.target.attrs?.id || event.target.parent?.attrs.id)?.contextMenu
        event.evt.preventDefault();
        if (event.target instanceof Stage === false && showContextMenu !== false) {
            this.knDataService.selectedNodeGroupId = event.target.attrs?.id || event.target.parent?.attrs.id
            contextMenuEl.style.top = stage.getPointerPosition()!.y + 4 + 'px';
            contextMenuEl.style.left = stage.getPointerPosition()!.x + 4 + 'px';
            contextMenuEl.style.display = 'initial';
        }
    }

    emitContextMenuAction(actionDispatched: TGraphActionType) {
        this.contextAction.emit({action: actionDispatched, id: this.knDataService.selectedNodeGroupId})
    }
}